<template>
	<div>
		<ProgressLinear v-if="create_obj.length === 0"/>
		<CreateEventDialog
			v-if="create_obj.length !== 0"
			:visible="create_obj.length !== 0"
			:createObj="create_obj"
			:color="'#81CC00'"
			:currentTab="current_tab_local"
			:isClose="false"
			:fullScreen="true"
			:adbid="adbid"
			:joid="joid"
			:coid="coid"
			:tasid="tasid"
			:startTime="start_time"
			:endTime="end_time"
			:jpid="jpid"
			@close="onCreateEventDialogClose()"
		/>
	</div>
</template>

<script>
import CreateEventDialog from "@/views/timesheets/create_event_dialog.vue";
import ProgressLinear from "@/components/progress/progress_double_linear.vue";
import config from "@/config.js";

const CREATE_ITEMS = config.create_items;
const Event_Holiday = 'holiday';
const Task = 'task';
const DiaryNewDialogue = 'DiaryNewDialogue';

/* If selected the user can manage public holidays */
const DPubHol = 'DPubHol';
/** If selected the user will be able to create and amend tasks */
const TR = 'TR';

export default {
	name: 'DiaryDialogue',
	data() {
		return {
			current_tab_local: 0,
			create_obj: [],
			adbid: 0,
			joid: 0,
			coid: 0,
			tasid: 0,
			start_time: '',
			end_time: '',
			jpid: 0
		}
	},
	components: {
		CreateEventDialog,
		ProgressLinear
	},
	created() {
		this.current_tab_local = Number(this.$route.params.current_tab);
		if (this.current_tab_local > 5) {
			this.current_tab_local = 0;
		}

		if (this.$route.name && this.$route.name === DiaryNewDialogue) {
			this.create_obj = CREATE_ITEMS.filter((item) => { return item.key === this.current_tab_local });

			this.adbid = this.$route.query.adbid ? Number(this.$route.query.adbid) : 0;
			this.joid = this.$route.query.joid ? Number(this.$route.query.joid) : 0;
			this.tasid = this.$route.query.tasid ? Number(this.$route.query.tasid) : 0;
			this.start_time = this.$route.query.start_time && this.$route.query.start_time.length !== 0 ? this.$route.query.start_time : '';
			this.end_time = this.$route.query.end_time && this.$route.query.end_time.length !== 0 ? this.$route.query.end_time : '';
			this.jpid = this.$route.query.jpid ? Number(this.$route.query.jpid) : 0;
		} else {
			this.adbid = this.$route.query.adbid ? Number(this.$route.query.adbid) : 0;
			this.joid = this.$route.query.joid ? Number(this.$route.query.joid) : 0;
			this.coid = this.$route.query.coid ? Number(this.$route.query.coid) : 0;
			this.tasid = this.$route.query.tasid ? Number(this.$route.query.tasid) : 0;
			this.start_time = this.$route.query.start_time && this.$route.query.start_time.length !== 0 ? this.$route.query.start_time : '';
			this.end_time = this.$route.query.end_time && this.$route.query.end_time.length !== 0 ? this.$route.query.end_time : '';
			this.jpid = this.$route.query.jpid ? Number(this.$route.query.jpid) : 0;

			this.filterCreateTab();
		}
	},
	methods: {
		async filterCreateTab() {
			const url = "/api/user/me/privileges";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;
					
					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data } = json;
					if (status === 'OK') {
						let create_items = CREATE_ITEMS;
						
						if (!data.includes(DPubHol)) {
							create_items = create_items.filter(c => {return c.value !== Event_Holiday});

							if (this.current_tab_local === 4) {
								this.current_tab_local = 0;
							}
						}

						if (!data.includes(TR)) {
							create_items = create_items.filter(c => {return c.value !== Task});

							if (this.current_tab_local === 1) {
								this.current_tab_local = 0;
							}
						}

						this.create_obj = create_items;
					}
				})
				.catch((e) => {
					console.log(e.message)
				});

		},
		onCreateEventDialogClose() {
			window.open("/close")
		}
	}
}
</script>
<style lang="scss" scoped>

</style>